<template>
  <div
    v-if="options?.date?.length > 0"
    ref="formRef"
    class="block-event-subscription"
  >
    <FormController
      v-if="data.form && data.form.length === 1"
      :data="data.form[0]"
      :is-loading="isLoading"
      @on-submit="formAction"
    >
      <AtomButton
        button-type="submit"
        :is-disabled="isLoading"
        :text="data.form[0].button_text"
      />
    </FormController>
  </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

/*
  Get available dates of event
*/
const storyStore = useStoryStore();
const { dayjs } = useDayJs();
const connectedDates = storyStore.getConnectedStrapiValue('dates');

const dates = computed(() => {
    if (!Array.isArray(connectedDates)) {
        return [];
    }

    return connectedDates.map((date) => {
        const formatted = dayjs(date.date);
        return {
            _uid: Math.random() + date.date,
            value: formatted,
        };
    });
});

/* Sort dates */
dates.value?.sort((a, b) => {
    const dateA = dayjs(a.value);
    const dateB = dayjs(b.value);

    if (dateA.isBefore(dateB)) {
        return -1;
    }
    if (dateA.isAfter(dateB)) {
        return 1;
    }
    return 0;
});

const options = computed(() => ({
    date: dates.value?.filter((date) => {
        const now = dayjs();
        return dayjs(date.value).isAfter(now);
    }) || [],
}));

/* formate all dates in options */
options.value.date.forEach((date) => {
    // eslint-disable-next-line no-param-reassign
    date.value = dayjs(date.value).format('DD.MM.YYYY HH:mm');
});

provide('options', options);

const eventData = computed(() => ({
    name: storyStore.getConnectedStrapiValue('name'),
}));

/*
  Form Handling
*/
const formRef = ref(null);

const {
    isLoading,
    send,
} = useFormAction(formRef);

const strapiClient = useStrapiClient();
const formAction = async (values) => {
    const submitValues = { ...values };
    delete submitValues.statusData;

    submitValues.eventName = eventData.value.name;

    await send(async () => {
        await strapiClient('event/subscribe', {
            method: 'POST',
            body: submitValues,
        });
    }, values);
};
</script>

<style lang="scss" scoped>
.block-event-subscription {
    @include default-content-columns();
    @include fluid('margin-bottom', 20px, 40px);
}
</style>
